import { render, staticRenderFns } from "./NewTemplate.vue?vue&type=template&id=8b3f438a&scoped=true"
import script from "./NewTemplate.vue?vue&type=script&lang=js"
export * from "./NewTemplate.vue?vue&type=script&lang=js"
import style0 from "./NewTemplate.vue?vue&type=style&index=0&id=8b3f438a&prod&scoped=true&lang=scss"
import style1 from "./NewTemplate.vue?vue&type=style&index=1&id=8b3f438a&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8b3f438a",
  null
  
)

export default component.exports